// Copyright © 2021 Move Closer

import { ClassRegistry } from '../../../dsl/_contracts'
import { TitleVersion } from '../../_contracts'
import { GradientDomain } from '../../Tile/Tile.contracts'

/**
 * Tile's sizing variant.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export enum TileSize {
  XL = 'XL',
  L = 'L',
  S = 'S'
}

export enum TileSizeMobile {
  TILE_PLUS_TEXT = 'tile-text',
  TILE = 'tile',
}

export enum ListType {
  LIST = 'list',
  THUMBNAILS = 'thumbnail_list'
}

export interface ListTileConfig {
  showArticleTags: boolean;
  titleVersion?: TitleVersion;
  tile: TileConfig;
}

/**
 * Registry that binds the `TileSize` with the applicable CSS class.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export type TileSizeClassRegistry = ClassRegistry<TileSize>

/**
 * Configuration settings required by the `<Tile>` component.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.mileczek@movecloser.pl>
 */
export interface TileConfig {
  /**
   * Determines if the article is premium
   */
  isPremium: boolean;

  /**
   * Determines whether the article tags should be shown.
   */
  showArticleTags: boolean;

  /**
   * Determines whether the author's avatar should be shown.
   */
  showAuthorAvatar: boolean;

  /**
   * Determines whether the author's name should be shown.
   */
  showAuthorName: boolean;

  /**
   * Determines category should be shown - only for Xl and L tile.
   */
  showCategory?: boolean;

  /**
   * Determines whether the article's publication date should be shown.
   */
  showPublicationDate: boolean;

  /**
   * Determines whether the article's title should be shown.
   */
  showTitle: boolean;

  /**
   * Tile's sizing variant.
   */
  size: TileSize;

  /**
   * Mobile Tile's sizing variant.
   */
  mobileSize?: TileSizeMobile;

  /**
   * Determines whether the article's title
   * should be shown ON TOP OF or BELOW the thumbnail.
   */
  titleOnImage: boolean;

  /**
   * The HTML tag that should be used to render the tile's title.
   */
  titleTag?: string;

  /**
   * Version of the title that should be displayed within each article item.
   */
  titleVersion?: TitleVersion;

  /**
   * Determines gradient color for tile based on domain.
   */
  gradientColor?: GradientDomain;

  /**
   * Determines whether the module should be shown on the first page only.
   */
  showModuleOnFirstPageOnly?: boolean;
}
